import { MainV3ApiBase } from './base';
import { MembershipTokenIndexView } from '../types/membershipTokens';
import { MembershipItemId } from '../../commonv3/types/membershipPlans';

export enum OperationType {
  UPDATE = 'update',
  CANCEL = 'cancel',
}

export const MembershipUpdateRequestApis = {
  create(
    currentItemId: MembershipItemId,
    nextItemId: MembershipItemId,
    operationType = OperationType.UPDATE
  ): Promise<MembershipTokenIndexView[]> {
    return MainV3ApiBase.appendPath('users/current/membership_update_requests').post({
      current_item_id: currentItemId,
      next_item_id: nextItemId,
      operation_type: operationType,
    });
  },
};
